var _Object$keys = require('babel-runtime/core-js/object/keys').default;

(function () {
  Motion.file('inspector/view.js', function (require) {
    var _lodash = require('lodash');

    function pathToName(path) {
      var p = path.split(',');
      return p[p.length - 1].split('-')[0];
    }

    function filterProps(props) {
      var leaveOut = ['if', 'repeat', 'style', 'yield', '__motion'];
      return _lodash.omit.apply(null, [props].concat(leaveOut));
    }

    Motion.staticStyles('Inspector.View', {
      '$view': '#_motiondevtools view.Inspector-View, #_motiondevtools .Inspector-View.view, #_motiondevtools .ViewInspector-View.view',
      '$top': '#_motiondevtools top.Inspector-View, #_motiondevtools .Inspector-View.top, #_motiondevtools .ViewInspector-View.top',
      '$active': '#_motiondevtools active.Inspector-View, #_motiondevtools .Inspector-View.active, #_motiondevtools .ViewInspector-View.active',
      '$highlight': '#_motiondevtools highlight.Inspector-View, #_motiondevtools .Inspector-View.highlight, #_motiondevtools .ViewInspector-View.highlight',
      '$Close': '#_motiondevtools .ViewInspector-View .ViewClose',
      '$name': '#_motiondevtools name.Inspector-View, #_motiondevtools .Inspector-View.name, #_motiondevtools .ViewInspector-View.name',
      '$edit': '#_motiondevtools edit.Inspector-View, #_motiondevtools .Inspector-View.edit, #_motiondevtools .ViewInspector-View.edit',
      '$expanded': '#_motiondevtools expanded.Inspector-View, #_motiondevtools .Inspector-View.expanded, #_motiondevtools .ViewInspector-View.expanded',
      '$input': '#_motiondevtools input.Inspector-View, #_motiondevtools .Inspector-View.input, #_motiondevtools .ViewInspector-View.input',
      '$title': '#_motiondevtools title.Inspector-View, #_motiondevtools .Inspector-View.title, #_motiondevtools .ViewInspector-View.title',
      '$section': '#_motiondevtools section.Inspector-View, #_motiondevtools .Inspector-View.section, #_motiondevtools .ViewInspector-View.section'
    }, {
      '$view': {
        position: 'relative',
        pointerEvents: 'auto',
        margin: 6,
        marginBottom: 0,
        padding: [0, 0, 1],
        minWidth: 220,
        minHeight: 34,
        fontSize: 12,
        userSelect: 'none',
        cursor: 'default',
        background: '#fff',
        boxShadow: '0px 2px 10px rgba(0,0,0,0.15)',
        border: '1px solid #ccc',
        borderRadius: 4,
        color: '#333',
        transition: 'all ease-in 60ms',
        opacity: 0
      },
      '$top': {
        flexFlow: 'row',
        paddingBottom: 10
      },
      '$active': {
        opacity: 1
      },
      '$highlight': {
        border: '2px solid #afb4e2'
      },
      '$Close': {
        top: -5,
        right: -5,
        fontSize: 13
      },
      '$name': {
        fontWeight: 400,
        color: 'rgba(0,0,0,0.8)',
        padding: [8, 8, 0],

        fontSize: 14
      },
      '$edit': {
        padding: [8, 8, 0],
        fontSize: 14,

        marginLeft: 4,
        fontWeight: 400,
        color: 'rgba(24, 101, 227, 0.8)'
      },
      '$expanded': {},
      '$input': {
        borderRadius: 100,
        border: '1px solid #ccc',
        width: '100%',
        padding: [2, 12],
        color: '#333',
        fontSize: 14
      },
      '$title': {
        display: 'none',
        color: '#333',
        fontWeight: 200,
        fontSize: 12,
        margin: [3, 0]
      },
      '$section': {
        background: [0, 0, 0, 0.05]
      }
    });
    Motion.view('Inspector.View', function (view, on, $) {
      var highlight = view.prop('highlight', undefined),
          closing = view.prop('closing', undefined),
          path = view.prop('path', undefined),
          onClose = view.prop('onClose', undefined);

      on.props(function () {
        highlight = view.getProp('highlight');
        closing = view.getProp('closing');
        path = view.getProp('path');
        onClose = view.getProp('onClose');
      });
      var inspect = window.Motion.inspect;
      var name = undefined;
      var active = false;
      var state = {};
      var props = null;
      var writeBack = null;

      function onSet(write) {
        view.props.writeBack(path, write);
      }

      on.delay(60, function () {
        view.set('active', active = true);
        view.updateSoft();
      });

      on.unmount(function () {
        delete window._Motion.inspector[path];
      });

      on.props(function () {
        if (closing === true) view.set('active', active = false);
        if (!path) return;

        view.set('name', name = pathToName(path));

        // if not inspecting, inspect
        if (!_Motion.inspector[path]) {
          inspect(path, function (_props, _state, _wb) {
            view.set('props', props = filterProps(_props || {}));
            view.set('state', state = _state || {});
            view.set('writeBack', writeBack = _wb);
            view.update();
            view.updateSoft();
          });
        }
        view.updateSoft();
      });

      var hasKeys = function hasKeys(o) {
        return o && _Object$keys(o).length > 0;
      };
      var edit = function edit() {
        return _DT.messageEditor({ type: 'focus:element', view: name });
      };view.render(function () {
        return view.el(
          ['view', 1],
          { className: { active: active, highlight: highlight } },
          view.el(['Close', 1], { onClick: onClose, fontSize: 20, size: 35 }),
          view.el(
            ['top', 1],
            null,
            view.el(
              ['name', 1],
              null,
              name
            ),
            Motion.iff(false) && view.el(
              ['edit', 1],
              { if: false, onClick: edit },
              'edit'
            )
          ),
          Motion.iff(hasKeys(props)) && view.el(
            ['Inspector.Section', 1],
            { title: 'Props', if: hasKeys(props), className: 'props' },
            view.el(['Tree', 1], { editable: false, data: props })
          ),
          Motion.iff(hasKeys(state)) && view.el(
            ['Inspector.Section', 2],
            { title: 'State', if: hasKeys(state) },
            view.el(['Tree', 2], {
              editable: true,
              onSet: onSet,
              data: state
            })
          )
        );
      });

      '788fafa9';

      $["view"] = function (_, _index) {
        return { transform: {
            x: 20
          }
        };
      };

      'd38b4a40';
      '45bafd14';

      $["active"] = function (_, _index) {
        return { transform: {
            x: 0
          }
        };
      };

      '2b6eec62';
      '73bd5771';
      '70140dec';

      $["name"] = function (_, _index) {
        return { margin: [0, 0, -6] };
      };

      '8fc3ee24';

      $["edit"] = function (_, _index) {
        return { margin: [0, 0, -6] };
      };

      $["expanded"] = function (_, _index) {
        return {
          transform: { y: 0 }
        };
      };

      '7e27a56e';
      '20639b6a';
      '72d32211';
    });
  })
})();
//# sourceMappingURL=view.js.map
